import { StyleSheet } from 'react-native';
import { spacing } from '../../shared/theme/spacing'
import { typography } from '../../shared/theme/typography';
import { ticketColors } from '../../shared/theme/ticketColors'
import { ticketSurfaces } from '../../shared/ticket/ticketSurfaces.styles';

export const addStockModalStyles = StyleSheet.create({
  keyboardRoot: {
    flex: 1,
  },
  modalCardShell: {
    maxHeight: '92%',
    overflow: 'hidden',
  },
  compactPickerInner: {
    flex: 1,
    minWidth: 0,
    gap: 1,
  },
  compactPickerCaption: {
    ...typography.caption,
    fontSize: 10,
    fontWeight: '700',
    color: ticketColors.ink3,
    textTransform: 'uppercase',
    letterSpacing: 0.35,
  },
  compactPickerValue: {
    ...typography.body,
    fontSize: 13,
    lineHeight: 18,
    fontWeight: '800',
    color: ticketColors.ink,
  },
  pickerBackdrop: {
    flex: 1,
    backgroundColor: ticketColors.dim,
    justifyContent: 'flex-end',
  },
  pickerCard: {
    backgroundColor: ticketColors.paper2,
    borderTopLeftRadius: 18,
    borderTopRightRadius: 18,
    paddingHorizontal: spacing.md,
    paddingTop: spacing.md,
    maxHeight: '78%',
    borderTopWidth: 1,
    borderColor: ticketColors.ruleSoft,
  },
  modalSheetHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: spacing.sm,
  },
  modalSheetTitle: {
    ...typography.body,
    fontSize: 17,
    fontWeight: '800',
    color: ticketColors.ink,
  },
  modalSheetScroll: {
    maxHeight: 420,
  },
  sheetRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: spacing.sm,
    paddingVertical: 12,
    paddingHorizontal: 4,
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: ticketColors.rule,
  },
  sheetRowSelected: {
    backgroundColor: 'rgba(255, 255, 255, 0.035)',
    marginHorizontal: -4,
    paddingHorizontal: 8,
    borderRadius: 10,
    borderBottomWidth: 0,
  },
  sheetRowTitle: {
    ...typography.body,
    color: ticketColors.ink,
    fontWeight: '700',
  },
  sheetRowTitleSelected: {
    color: ticketColors.ink,
  },
  entryScanFeedback: {
    marginTop: spacing.sm,
  },
  lookupAccent: {
    borderColor: ticketColors.gold,
    marginTop: spacing.sm,
  },
  lookupHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: spacing.sm,
  },
  lookupBadge: {
    ...typography.caption,
    color: ticketColors.goldInk,
    backgroundColor: ticketColors.gold,
    borderRadius: 999,
    paddingHorizontal: spacing.sm,
    paddingVertical: spacing.xs,
    fontWeight: '700',
  },
  lookupCta: {
    alignSelf: 'flex-start',
    marginTop: spacing.xs,
    paddingVertical: spacing.sm,
    paddingHorizontal: spacing.lg,
  },
  lastCostHint: {
    ...typography.caption,
    color: ticketColors.ink3,
    marginTop: 4,
    fontSize: 11,
  },
  expiryPastWarning: {
    ...typography.caption,
    color: ticketColors.warn,
    marginTop: 4,
    fontSize: 11,
    fontWeight: '600',
  },
  quantityInput: {
    fontSize: 18,
    fontWeight: '800',
    letterSpacing: 0.2,
  },
  supplierValue: {
    ...typography.body,
    fontSize: 14,
    fontWeight: '700',
    color: ticketColors.ink,
    flex: 1,
    minWidth: 0,
  },
  supplierValueMuted: {
    color: ticketColors.ink3,
    fontWeight: '600',
  },
  modalActionsWrap: {
    marginTop: spacing.sm,
    flexDirection: 'row',
    gap: spacing.sm,
    alignItems: 'stretch',
  },
  modalActionButton: {
    flex: 1,
    minWidth: 0,
    minHeight: 56,
    justifyContent: 'center',
    alignItems: 'center',
  },
  productCard: {
    ...ticketSurfaces.paperSheet,
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.sm,
    paddingVertical: 12,
    paddingHorizontal: 14,
    borderRadius: 14,
  },
  // Desktop (~860px wide): pares de campos en 2 columnas; mobile queda apilado.
  fieldRow: {
    flexDirection: 'row',
    gap: spacing.md,
  },
  fieldCol: {
    flex: 1,
    minWidth: 0,
  },
  productThumb: {
    width: 36,
    height: 36,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.tile,
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    flexShrink: 0,
  },
  productThumbImage: {
    width: '100%',
    height: '100%',
  },
  productCardBody: {
    flex: 1,
    minWidth: 0,
  },
  productCardName: {
    fontSize: 14,
    fontWeight: '700',
    color: ticketColors.ink,
  },
  productCardMeta: {
    fontSize: 12,
    fontWeight: '600',
    color: ticketColors.ink2,
    marginTop: 2,
  },
  productCardChange: {
    flexShrink: 0,
    paddingVertical: spacing.xs,
    paddingHorizontal: spacing.sm,
  },
  productCardChangeText: {
    ...typography.caption,
    color: ticketColors.gold,
    fontWeight: '700',
  },
});
